import { isSameOrAfter, isSameOrBefore, isValidDate } from 'src/utils/time';

export const checkValidDateBetweenDates = (
  date: string,
  max: string,
  min?: string,
) => {
  if (min) {
    return (
      isValidDate(date) && isSameOrAfter(date, min) && isSameOrBefore(date, max)
    );
  }
  return isValidDate(date) && isSameOrBefore(date, max);
};
